// extracted by mini-css-extract-plugin
export default {"total":"total__Q73F2H","switch":"switch__y8raB6","allData":"allData__HvTg6s","userData":"userData__qiBV83"};